import type { GivingCampaignGroupDto } from '../campaign.types'

import type { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'

export const getCampaignGroups: QueryFn<[string], GivingCampaignGroupDto[] | undefined> = async client => {
  const { data } = await client.get<{ data: GivingCampaignGroupDto[] }>('v1/giving-campaign-group', {
    withCredentials: true
  })

  return data.data
}
